module.exports = {
  common: {
    more: 'More',
    pageview: ' view',
    nodata: 'no data',
    next: 'NEXT',
    back: 'BACK',
    edit: 'Edit',
    deletes: 'Delete',
    submit: 'SUBMIT',
    logout: 'Logout',
    phoneCountry: 'Country Code',
    phoneArea: 'Area Code',
    login: 'Login/Registration',
    mobile: 'Mobile',
    code: 'Code',
    email: 'Email',
    userLogin: 'User Login',
    pleaseFillOut: 'Please Fill Out',
    surName: 'SurName',
    userinfo: "User Info",
    question: 'Question',
    colleagues: 'Colleagues',
    confirmation: 'Confirmation',
    isRequired: 'Mark <span class="required">*</span> is required',
    fillInAgain: 'Fill In Again',
    userCenter: 'To User Center',
    save: 'Save',
    success: 'Success',
    invite: 'Invite',
    continues: 'Continue',
    makeSure: 'Are You Sure To Logout?',
    tip: 'Tip',
    ok: 'Ok',
    cancel: 'Cancel',
    isloading: 'Loading...',
    isSubmit: 'Submiting...',
    agree: 'I agree to the privacy terms',
    privacyClause: 'Please Tick The Privacy Clause',
    other: 'Others（Please specific）'
  },
  usercenter: {
    useredit: 'Personal Info',
    more: 'More',
    subtitle: 'Confirmation',
  },
  infomenu: {
    person: 'Personal Data',
    category: 'Question'
  },
  question: {
    required: 'required',
    childrequired: 'Please select sub-questions',
    txtrequired: 'input is required',
    country: 'Country',
    state: 'State'
  },
  payment: {
    name: 'Name',
    money: 'Amount',
    state: 'State',
    promocode: 'Invitation Code',
    submit: 'Apply',
    selall: 'All',
    totalmoney: 'Total',
    paynow: 'PAY',
    btnskip: 'User Center',
    selpaytype: 'choose the mode of payment',
    paid: 'paid',
    unpaid: 'unpaid',
    company: 'Company',
    audited: 'Audited',
    unaudited: 'Unaudited',
    auditfail: 'Refused',
    used: 'Successful',
    wxpay: 'Wechat Pay',
    alipay: 'Ali Pay',
    jdpay: 'JD Pay',
    asia: 'Asia Pay',
  },
  colleague: {
    continueinv: 'Continue inviting',
    addcoll:'Add Colleagues',
  },
  login: {
  	loginFail: 'Login Fail',
    logining: 'Logining...'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js